import React, { useState, useEffect, useCallback } from "react";
import "../../Styles/yellowcalf.css/Wallet_Sales_Report.css";
import { simplePostCall } from "../../api/ApiServices";
import ApiConfig from "../../api/ApiConfig";
import ScaleLoader from "react-spinners/ScaleLoader";
import { formatNumber } from "../../utils/formatNumber";

function Wallet_Sales_Report() {
  const [salesData, setSalesData] = useState([]);
  const [studentList, setStudentList] = useState([]);
  const [loading, setLoading] = useState(false);

  const [filters, setFilters] = useState({
    studentId: "",
    startDate: "2021-01-27",
    endDate: "2026-02-02",
  });

  const fetchInitialData = useCallback(async () => {
    setLoading(true);
    try {
      const payload = {
        customer_id: Number(localStorage.getItem("customer_id")) || 1005,
        api_key:
          localStorage.getItem("api_key") || "b9359f494e77b6589ce12dd62518c585",
        language: "en",
        user_id: localStorage.getItem("user_id") || 14857,
        request_start_date: filters.startDate,
        request_end_date: filters.endDate,
        student_id: filters.studentId || "",
      };

      const response = await simplePostCall(
        ApiConfig.salesreporteports,
        JSON.stringify(payload),
      );

      if (response && response.result) {
        setSalesData(response.data || []);

        if (response.student_list && studentList.length === 0) {
          setStudentList(response.student_list);
        }
      }
    } catch (error) {
      console.error("Error fetching wallet sales report:", error);
    } finally {
      setLoading(false);
    }
  }, [filters, studentList.length]);

  useEffect(() => {
    fetchInitialData();
  }, [fetchInitialData]);

  const handleFilterChange = (e) => {
    const { id, value } = e.target;
    setFilters((prev) => ({
      ...prev,
      [id === "student_id"
        ? "studentId"
        : id === "startdate"
          ? "startDate"
          : "endDate"]: value,
    }));
  };

  const handleClear = () => {
    setFilters({
      studentId: "",
      startDate: "2021-01-27",
      endDate: "2026-02-02",
    });
  };

  return (
    <div className="fee-container">
      <div className="special-header panel-white-all">
        <h4 className="page-title">Wallet Sales Report</h4>
        <button className="btn btn-primary">Export</button>
      </div>

      <div className="yc-list-body">
        <div className="yc-list-filter">
          <select
            id="student_id"
            className="form-select"
            value={filters.studentId}
            onChange={handleFilterChange}
          >
            <option value="">Select Student</option>
            {studentList.map((std) => (
              <option key={std.student_id} value={std.student_id}>
                {std.student_name}
              </option>
            ))}
          </select>

          <input
            type="date"
            id="startdate"
            className="form-control"
            value={filters.startDate}
            onChange={handleFilterChange}
          />

          <input
            type="date"
            id="enddate"
            className="form-control"
            value={filters.endDate}
            onChange={handleFilterChange}
          />

          <button
            className="btn btn-primary"
            onClick={fetchInitialData}
            disabled={loading}
          >
            {loading ? "Searching..." : "Search"}
          </button>
          <button className="btn btn-primary" onClick={handleClear}>
            Clear
          </button>
        </div>

        <div className="yc-list-thead-card">
          <div className="yc-list-grid yc-list-grid-6">
            <div className="yc-list-cell">Sr.No</div>
            <div className="yc-list-cell">Date</div>
            <div className="yc-list-cell">Student Name</div>
            <div className="yc-list-cell">Admission No</div>
            <div className="yc-list-cell">Reference No</div>
            <div className="yc-list-cell">Amount</div>
          </div>
        </div>

        {loading ? (
          <div className="d-flex justify-content-center align-items-center" style={{ height: "20vh" }}>
            <ScaleLoader color="#F4BB44" />
          </div>
        ) : salesData.length > 0 ? (
          <div className="yc-list-row-list">
            {salesData.map((item, index) => (
              <div key={item.sale_id || index} className="yc-list-row-card">
                <div className="yc-list-grid yc-list-grid-6">
                  <div className="yc-list-cell">{index + 1}</div>
                  <div className="yc-list-cell">{item.formatted_date}</div>
                  <div className="yc-list-cell">{item.student_name}</div>
                  <div className="yc-list-cell">{item.student_admission_num}</div>
                  <div className="yc-list-cell">{item.sale_reference_no || "—"}</div>
                  <div className="yc-list-cell yc-amount-positive">
                    {formatNumber(item.sale_amount)}
                  </div>
                </div>
              </div>
            ))}
          </div>
        ) : (
          <div className="yc-empty-state">No records found.</div>
        )}
      </div>
    </div>
  );
}

export default Wallet_Sales_Report;
